<generic-page *ngIf="_appService.CoreCommonLiterals && _gearAppService.GearMonitorLiterals"
[title]="_gearAppService.GearMonitorLiterals.IncidentManagement | replaceLiterals:[generalLiteral]"
[errorMessage]="_errorBackEnd"
[goBackOnCancel]="false"
[isGeneric]="true">
  <div class="container-fluid">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item" id="alert-tab-details">
        <a id="alert-tab-details-item" type="button" class="nav-link" role="tab" (click)="activeTab = 1" [ngClass]="{'active': activeTab === 1}">Turnos</a>
      </li>
      <li class="nav-item" id="alert-tab-notifications">
        <a id="alert-tab-notifications-item" type="button" class="nav-link" role="tab" (click)="activeTab = 2" [ngClass]="{'active': activeTab === 2}">Comunicados</a>
      </li>
      <li class="nav-item" id="alert-tab-notifications">
          <a id="alert-tab-notifications-item" type="button" class="nav-link" role="tab" (click)="activeTab = 3" [ngClass]="{'active': activeTab === 3}">Eventos</a>
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 1}">
        <app-custom-table 
        [data]="shiftsTableData" 
        [enablePagination]="true" 
        [enableRowsPerPage]="true">
        </app-custom-table>
      </div>
    </div>
    <div class="tab-content">
      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 2}">
        <app-communications></app-communications>
      </div>
    </div>
    <div class="tab-content">
      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 3}">
        <app-incidents #incidents></app-incidents>
      </div>
    </div>
  </div>
</generic-page>